import { render, staticRenderFns } from "./InitioBackButton.vue?vue&type=template&id=e07fcf76&scoped=true&"
import script from "./InitioBackButton.vue?vue&type=script&lang=js&"
export * from "./InitioBackButton.vue?vue&type=script&lang=js&"
import style0 from "./InitioBackButton.vue?vue&type=style&index=0&id=e07fcf76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07fcf76",
  null
  
)

export default component.exports